import gsap from 'gsap';
import { SplitText } from 'gsap/all';

import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Ease } from '../_app/cuchillo/utils/Ease';

// Reprodueix l'animació de l'AudioLayer (AudioController.showLayer): el text es revela
// per paraules (y + rotate → 0, staggered) i el button-torcido (aquí un <a> a la home)
// s'obre en amplada amb el seu <span> fent fade. Extèn Scroll_Item base (no BlockDefault)
// perquè volem aquesta animació concreta i no la reveal de títols/botons del bloc default.
class ScrollItem__NotFound extends Scroll_Item {
  _text = [];
  _torcido = null;
  _torcidoSpan = null;
  _torcidoW = 0;
  _torcidoH = 0;

  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    // button-torcido: l'<a> és la màscara (amplada animada), l'<span> intern porta
    // padding + text. Estat inicial: amplada 0, span amagat.
    this._torcido = GetBy.selector('.button-torcido', __link)[0];
    this._torcidoSpan = this._torcido ? GetBy.selector('span', this._torcido)[0] : null;
    if (this._torcido) {
      this._torcidoW = this._torcido.offsetWidth;
      this._torcidoH = this._torcido.offsetHeight;
      gsap.set(this._torcido, { width: 0, height: this._torcidoH });
      if (this._torcidoSpan) gsap.set(this._torcidoSpan, { opacity: 0 });
    }

    // Text per paraules (mateixa reveal que l'AudioLayer): cada paraula baixa i girada.
    const textEl = GetBy.class('text', __link)[0];
    if (textEl) {
      this._text = new SplitText(textEl, { type: 'words', wordsClass: 'line-child' }).words;
      if (this._text.length) {
        const tempHeight = this._text[0].offsetHeight;
        gsap.set(this._text, { y: tempHeight * 3, rotate: 20 });
      }
    }

    this.onShow = () => this.showCb();
  }

  showCb() {
    if (this._text.length) {
      gsap.to(this._text, {
        y: 0,
        rotate: 0,
        duration: 1,
        force3D: true,
        ease: Ease.EASE_CUCHILLO_IN_OUT,
        stagger: 0.08,
      });
    }

    if (this._torcido) {
      gsap.to(this._torcido, { width: this._torcidoW, duration: 1.5, delay: 0.5, ease: 'power3.out' });
    }
    if (this._torcidoSpan) {
      gsap.to(this._torcidoSpan, { opacity: 1, duration: 0.1, delay: 0.7 });
    }
  }

  resize(__w, __h) {
    super.resize(__w, __h);
  }
}

Scroll._registerClass('NotFound', ScrollItem__NotFound);

export default ScrollItem__NotFound;
